import React from 'react'
import { Helmet } from 'react-helmet-async'

import { resources } from 'config'

import useStructuredData from './hook'

type TestProps = {
  testId?: string
}

/**
 * Renders all mounted schema.org "Thing" objects as separate JSON-LD script tags.
 * Multiple components can mount schemas simultaneously and all will be rendered.
 * As components dismount, they dismount their schema as well.
 * @returns schema.org compliant JSON+LD script tags or null when this Consumer is used outside its context.
 */
const Consumer = (props: TestProps) => {
  const ctx = useStructuredData()
  const schemas = ctx?.schemas
  if (
    !schemas ||
    schemas.length === 0 ||
    resources.schemaHostBlocklist.includes(ctx.hostname)
  ) {
    return null
  }
  return (
    <Helmet>
      {schemas.map((schema, index) => (
        <script
          key={index}
          type='application/ld+json'
          data-testid={
            props.testId
              ? `${props.testId}${schemas.length > 1 ? `-${index}` : ''}`
              : undefined
          }
        >
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  )
}

export default Consumer
